"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolePilotTokens = exports.IkeToken = void 0;
exports.IkeToken = {
    ADMIN_COMPANY_CREATE: 'company-creation',
    ADMIN_ORG_CREATE: 'org-creation',
    ADMIN_ORG_UPDATE: 'org-update',
    COLLECTION_DELETE: 'collection-delete',
    COMPANY_ACCOUNTS: 'company-accounts',
    INSIGHT_REPROCESS: 'insight-reprocess',
    /**
     * @deprecated
     */
    COMPANY_RESET_PASSWORD: 'company-user-password-reset',
    /**
     * @deprecated
     */
    COMPANY_USER_CREATE: 'company-user-creation',
    /**
     * @deprecated
     */
    COMPANY_USER_DELETE: 'company-user-deletion',
    COMPANY_USER_INVITE: 'company-user-invite',
    /** Display raw images instead of thumbnails in the IKE Report (IKE4-356) */
    REPORT_FULL_SIZE_IMAGES: 'report-full-size-images',
    /** Can create short IKE report */
    FEATURE_REPORT_SHORT: 'feature.report.short',
    /** Can create IKE report Composite Photo */
    FEATURE_REPORT_COMPOSITE_PHOTO: 'feature.report.composite.photo',
    /** Can create IKE report photo */
    FEATURE_REPORT_PHOTO: 'feature.report.photo',
    /** Can create IKE only composite photo report  */
    FEATURE_REPORT_COMPOSITE_ONLY: 'feature.report.composite.only',
    ELASTIC_CREATE_STATUS_EVENTS: 'elastic-create-status-events',
    /** Allow the user to rename a tag (job), as well a move collections to tags within the same department */
    TAG_JOB_UPDATE: 'update-job-tag',
    /** Can the user manage IKE devices. Restricted to ikeGPS support. */
    DEVICE_MANAGE: 'device.manage',
    /**
     * @deprecated
     */
    EXPORT_CUSTOM: 'export-custom',
    COLLECTION_EXPORT_HIDE_FLAGGED_PHOTOS: 'collection.export.hide.flagged.photos',
    /** Can the user use the wire measurement calipers on the zoom screen */
    FEATURE_WIRE_MEASURE: 'feature-wire-measure',
    /** Can the user use the collection editor on the map screen */
    FEATURE_MAP_EDIT: 'feature-map-edit',
    /** Can the user see vectors on the map (requested by IKE Analyze) */
    FEATURE_MAP_VECTOR: 'feature.map.vector',
    /** Can the user import collections with a CSV file */
    FEATURE_IMPORT_CSV: 'feature-import-csv',
    /** Can the user import collections with a EXCEL file (requires feature-import-csv as well) */
    FEATURE_IMPORT_EXCEL: 'feature-import-excel',
    /** Can the user import forms */
    FEATURE_IMPORT_FORM: 'feature.import.form',
    /** Can the user sort collections by status (requested by IKE Analyze) */
    FEATURE_SORT_STATUS: 'feature.sort.status',
    /** Can the user see accuracy information about collection location fields (requested by SCE) */
    FEATURE_COLLECTION_LOCATION_ACCURACY: 'feature.collection.location.accuracy',
    /** Can the user assign collections to users (requested by IKE Analyze) */
    FEATURE_COLLECTION_ASSIGN: 'feature.collection.assign',
    /** Can the user copy height attachments when duplicating a subform (requested by IKE Analyze) */
    FEATURE_COLLECTION_SUBFORM_MEASUREMENT_COPY: 'feature.collection.subformMeasurementCopy',
    /** Can the user delete forms */
    FEATURE_FORM_DELETE: 'feature.form.delete',
    /** Can the user share forms with other departments (front-end not implemented) */
    FEATURE_FORM_SHARE: 'feature.form.share',
    /** Can the user use vertical separation in forms */
    FEATURE_FORM_VERTICAL_SEPARATION: 'feature.form.verticalSeparation',
    /** Can the user move collections between departments */
    FEATURE_COLLECTION_MOVE: 'feature.collection.move',
    /** Enables the ability for a user migrate collections between forms */
    FEATURE_COLLECTION_FORM_MIGRATE: 'feature.collection.form.migrate',
    /** Can the user reference another collection when defining a vector (requested by SCE and IKE Analyze) */
    FEATURE_COLLECTION_LINK: 'feature.collection.link',
    /** Can the user see extended vector information in the KML report */
    FEATURE_KML_VECTOR_DETAIL: 'feature.kml.vector.detail',
    /** Expose altitude values as NAVD88 in addition to existing altitude values (Excel export only at this stage) */
    FEATURE_ALTITUDE_NAVD88: 'feature.altitude.navd88',
    /** Department can have extra user roles (editor, viewer, downloader, data_admin) */
    FEATURE_EXTRA_ROLES: 'feature.extra.roles',
    /** Can the user use secondary label with forms*/
    FEATURE_SECONDARY_LABEL: 'feature.secondary.label',
    FEATURE_HIDE_FIELD: 'feature.hide.field',
    /** This feature is for Crown Castle. Coloring the collections on the maps by site type*/
    FEATURE_COLLECTION_COLORING: 'feature.collection.coloring',
    /**
     * This feature group will be used to give access to all IKE Analyze features. One token to rule them all, and in the darkness, bind them.
     * Already existing tokens for ike analyze features are still to be migrated to use this token instead
     * */
    FEATURE_GROUP_IKE_ANALYZE: 'feature.group.ike.analyze',
    /** Can the user duplicate collections */
    FEATURE_COLLECTION_DUPLICATE: 'feature.collection.duplicate',
    /** Can the user see IKE device field of view on the mini map */
    FEATURE_MAP_FIELD_OF_VIEW: 'feature.map.field.of.view',
    /** Can the user select multiple jobs or collections within the map page list on the left */
    FEATURE_CTRL_SHIFT_SELECT: 'feature.ctrl.shift.select',
    /** Shows the north indicator on the photomeasure image */
    FEATURE_PHOTOMEASURE_COMPASS: 'feature.photomeasure.compass',
    /** Shows the roll indicator on the photomeasure image */
    FEATURE_PHOTOMEASURE_ROLL: 'feature.photomeasure.roll',
    PERMISSION_VERSION_CREATE: 'permission.version.create',
    /** ~~Allow access to ikebot~~ Allows write access to the office admin dashboard */
    PERMISSION_BOT: 'permission.bot',
    /**
     * @deprecated
     */
    PERMISSION_ROLE_ASSUME: 'permission.role.assume',
    /** Allow for organization wide page access */
    ORG_SEARCH_PAGE: 'org.search.page',
    /** Allow for dashboard page */
    DASHBOARD_PAGE: 'dashboard.page',
    /** Allow Span O Matic access */
    SPAN_O_MATIC: 'span.o.matic',
    /** Allow map based review mode aka "map mode" access */
    FEATURE_MAP_MODE: 'feature.map.mode',
    /** Show color coding on photomeasure page */
    PHOTOMEASURE_COLOR_CODING: 'photomeasure.color.coding',
    /** Show and set up flagged colors */
    FEATURE_COLOR_FLAG: 'feature.color.flag',
    /** Show the "IKE Office Pro" branding */
    FEATURE_IKE_OFFICE_PRO: 'feature.pro.ike.office',
    /** Dispatch the Image QA event on collection upload */
    FEATURE_COLLECTION_IMAGE_QUALITY_ASSURANCE: 'feature.collection.image.quality.assurance',
    /** Custom token for ComEd to display a link to their Esri dashboard in the nav draw */
    FEATURE_COMED_MAP_LINK: 'feature.comed.map.link',
    /** Allow uploading Captures from IKE Office */
    FEATURE_OFFICE_IMAGE_UPLOAD: 'feature.office.image.upload',
    /** Allow importing form from IKE PoleForeman DB */
    FEATURE_IPF_DB_IMPORT: 'feature.ipf.db.import',
    /**
     * Allow able to set the annotation 'label' to a tool field that applies something as an annotation on a photo
     *
     * i.e. height tool, vertical separation tool
     */
    FEATURE_MARKER_LABEL: 'feature.token.marker.label',
    /** Enables Revision History page. */
    FEATURE_REVISION_HISTORY: 'feature.revision.history',
    /** Enable the display of all photo types in the photo measure page */
    FEATURE_DISPLAY_ALL_PHOTOS: 'feature.display.all.photos',
    /** Enables the IKE Insight ahoa feature, enables insight markers AND insight masks */
    FEATURE_INSIGHT_AHOA: 'feature.insight.ahoa',
    /** Enables displaying of the detection class as label of insight marker*/
    FEATURE_INSIGHT_MARKER_LABELS: 'feature.insight.marker.labels',
    /** Insight marker tokens */
    FEATURE_INSIGHT_MARKER_STREETLIGHT: 'feature.insight.marker.streetlight',
    FEATURE_INSIGHT_MARKER_TRANSFORMER: 'feature.insight.marker.transformer',
    FEATURE_INSIGHT_MARKER_POLE_TOP: 'feature.insight.marker.pole_top',
    FEATURE_INSIGHT_MARKER_ZERO_OFFSET: 'feature.insight.marker.zero_offset',
    FEATURE_INSIGHT_MARKER_THREE_FEET_MARKER: 'feature.insight.marker.three_feet_marker',
    FEATURE_INSIGHT_MARKER_SIX_FEET_MARKER: 'feature.insight.marker.six_feet_marker',
    FEATURE_INSIGHT_MARKER_NINE_FEET_MARKER: 'feature.insight.marker.nine_feet_marker',
    FEATURE_INSIGHT_MARKER_WIRE: 'feature.insight.marker.wire',
    FEATURE_INSIGHT_MARKER_GUY_WIRE: 'feature.insight.marker.guy_wire',
    FEATURE_INSIGHT_MARKER_RISER: 'feature.insight.marker.riser',
    FEATURE_INSIGHT_MARKER_CUTOUT: 'feature.insight.marker.cutout',
    FEATURE_INSIGHT_MARKER_CAPACITOR: 'feature.insight.marker.capacitor',
    /** Tokens to control which insight mask types to display. Should only be enabled or disabled globally, requires Insight ahoa feature enabled */
    FEATURE_INSIGHT_MASK_POLE: 'feature.insight.mask.pole',
    FEATURE_INSIGHT_MASK_TRANSFORMER: 'feature.insight.mask.transformer',
    FEATURE_INSIGHT_MASK_STREETLIGHT: 'feature.insight.mask.streetlight',
    FEATURE_INSIGHT_MASK_WIRE: 'feature.insight.mask.wire',
    FEATURE_INSIGHT_MASK_RISER: 'feature.insight.mask.riser',
    FEATURE_INSIGHT_MASK_RECLOSER: 'feature.insight.mask.recloser',
    FEATURE_INSIGHT_MASK_CAPACITOR: 'feature.insight.mask.capacitor',
    FEATURE_INSIGHT_MASK_CUTOUT_ARRESTOR: 'feature.insight.mask.cutout-arrestor',
    FEATURE_INSIGHT_MASK_REGULATOR: 'feature.insight.mask.regulator',
    FEATURE_INSIGHT_MASK_SWITCH: 'feature.insight.mask.switch',
    FEATURE_INSIGHT_MASK_CROSSARM: 'feature.insight.mask.crossarm',
    /** Enables the markers sheet in excel export */
    FEATURE_EXCEL_MARKERS: 'feature.excel.markers',
    /** Enable the Arrange Annotations button in photomeasure */
    FEATURE_ANNOTATIONS_ARRANGE: 'feature.annotations.arrange'
};
/**
 * Tokens that are part of the PolePilot feature group (FEATURE_INSIGHT_AHOA).
 * These tokens should only be available when the main PolePilot token is enabled.
 */
exports.PolePilotTokens = [
    exports.IkeToken.FEATURE_ANNOTATIONS_ARRANGE,
    exports.IkeToken.FEATURE_INSIGHT_MASK_POLE,
    exports.IkeToken.FEATURE_INSIGHT_MASK_TRANSFORMER,
    exports.IkeToken.FEATURE_INSIGHT_MASK_STREETLIGHT,
    exports.IkeToken.FEATURE_INSIGHT_MASK_WIRE,
    exports.IkeToken.FEATURE_INSIGHT_MASK_RISER,
    exports.IkeToken.FEATURE_INSIGHT_MASK_RECLOSER,
    exports.IkeToken.FEATURE_INSIGHT_MASK_CAPACITOR,
    exports.IkeToken.FEATURE_INSIGHT_MASK_CUTOUT_ARRESTOR,
    exports.IkeToken.FEATURE_INSIGHT_MASK_REGULATOR,
    exports.IkeToken.FEATURE_INSIGHT_MASK_SWITCH,
    exports.IkeToken.FEATURE_INSIGHT_MASK_CROSSARM,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_POLE_TOP,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_TRANSFORMER,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_STREETLIGHT,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_WIRE,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_ZERO_OFFSET,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_GUY_WIRE,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_RISER,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_CUTOUT,
    exports.IkeToken.FEATURE_INSIGHT_MARKER_CAPACITOR
];
//# sourceMappingURL=token.js.map